(function ($) {
  Drupal.behaviors.pcemshare = {

    attach: function (context, settings) {
      $('#pc_em_mod2', context).once('pcemshare', function () {});
      // Have the link text highlighted for the user
      // when the Share Overlay opens.
      function SelectText(element) {
        var doc = document,
          text = doc.getElementById(element),
          range, selection;

        if (doc.body.createTextRange) {
          range = document.body.createTextRange();
          range.moveToElementText(text);
          range.select();
        } else if (window.getSelection) {
          selection = window.getSelection();
          range = document.createRange();
          range.selectNodeContents(text);
          selection.removeAllRanges();
          selection.addRange(range);
        }
      }
      // Apply text selection.
      $(function () {
        $('#pc_love__shareIconImg').click(function () {
          SelectText('boutique__video_top-video-Share-Link');
        });
      });

      // Open the Share Overlay.
      $('#pc_love__shareIconImg').click(function () {
        $('#boutique__video_top-video-Share').fadeIn(200);
      });
    }
  };
})(jQuery);
